import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import Main from "./layout/Main";
import Loader from "./Loader";

const PrivateRoute = ({ children }) => {

  const location = useLocation();
  const token = localStorage.getItem("token");

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Main>{children}</Main>;
};

export default PrivateRoute;
